<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:right-content="page.rightContent"
		/>

		<section class="gallery-section">
			<filter-buttons :items="categories" :filter="filter" @change-filter="filter = $event" />
			<image-grid :items="galleryFiltered" :filter="filter" @change-filter="filter = $event" />
		</section>

		<contentblocks
			v-if="page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:contentblocks-content="page.contentBlockContent"
		/>
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection && page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].newsletterForm.title"
			:content="defaults[locale].newsletterForm.content"
			:email="defaults[locale].newsletterForm.email"
			:button="defaults[locale].newsletterForm.button"
		/>
	</page-container>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const filter = ref('showAll');

const { data: gallery } = await useWebsiteFetch('gallery', {
	query: { language: locale.value },
	key: `${locale.value}/gallery`,
});

const categories = [
	...new Set(gallery.value.map(({ galleryCategorie }) => galleryCategorie && galleryCategorie.header)),
];

const galleryFiltered = computed(() => {
	if (filter.value === 'showAll') {
		return gallery.value;
	}

	return [...gallery.value].filter((item) => {
		if (!item.galleryCategorie) {
			return false;
		}

		return item.galleryCategorie.header === filter.value;
	});
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.main-content {
	padding: 100px 0 50px;
}

.video-play {
	background: url('~/assets/images/video-play-button.png') no-repeat center center;
	background-size: 40px;
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 3;
	width: 40px;
	height: 40px;
	margin: -20px 0 0 -20px;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
}

.gallery-section img {
	width: 100%;
	padding: 0;
}

.gallery-items {
	margin: 50px auto;
	font-size: 0;
	text-align: left;
	display: flex;
	flex-flow: row wrap;

	a {
		cursor: pointer;
	}

	.column4 {
		float: none;
		margin: 0;
		padding: 20px;
		width: 33.3333%;
		vertical-align: top;
		position: relative;

		&:hover span {
			opacity: 1;
		}
	}

	span {
		font-size: 1rem;
		opacity: 0;
		position: absolute;
		left: 30px;
		right: 30px;
		bottom: 30px;
		padding: 25px;
		transition: all 0.3s ease-in-out;
		color: #fff;
		background: rgb(0 0 0 / 40%);
	}

	.gallery-title i {
		margin: 0 5px 0 0;
	}
}

@media (max-width: 960px) {
	.gallery-items .column4 {
		width: 50%;
		max-width: 600px;
	}
}

@media (max-width: 600px) {
	.gallery-items .column4 {
		padding: 10px;
	}
}
</style>
